import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

// Matches base62 short codes: 6–20 alphanumeric chars
const SHORT_CODE_REGEX = /^[A-Za-z0-9]{6,20}$/;

type Status = 'resolving' | 'invalid';

export default function ShortLinkRedirectPage() {
  const { code } = useParams<{ code: string }>();
  const [status, setStatus] = useState<Status>('resolving');

  useEffect(() => {
    if (!code || !SHORT_CODE_REGEX.test(code)) {
      setStatus('invalid');
      return;
    }

    if (import.meta.env.DEV) {
      // eslint-disable-next-line no-console
      console.debug(`[ShortLink] resolving code length=${code.length}`);
    }

    window.location.replace(`${import.meta.env.VITE_MINT_BASE_URL}/s/${code}`);
  }, [code]);

  return (
    <div className="min-h-[100dvh] bg-slate-50 flex flex-col items-center justify-center px-4 text-center">
      {status === 'resolving' && (
        <>
          <svg
            className="animate-spin h-10 w-10 text-blue-500 mb-5"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            />
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
            />
          </svg>
          <p className="text-slate-600 text-base font-medium">Se deschide chestionarul…</p>
        </>
      )}

      {status === 'invalid' && (
        <div className="bg-white rounded-2xl shadow-md border border-slate-100 px-8 py-10 max-w-sm w-full">
          <div className="text-4xl mb-4">❌</div>
          <h1 className="text-xl font-bold text-slate-800 mb-2">Link invalid</h1>
          <p className="text-sm text-slate-500 leading-relaxed">
            Link-ul nu este valid sau a fost deja șters. Vă rugăm să verificați link-ul primit.
          </p>
        </div>
      )}
    </div>
  );
}
